import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { XpKitModule } from '@shared/modules/xp-kit.module';
import { AppMaterialModule } from 'app/app-material.module';
import { OperatorLoginComponent, OperatorSignupComponent } from 'app/operator';
import { OneTimePasswordComponent } from 'app/components/operator/one-time-password/one-time-password.component';

@NgModule({
	declarations: [
		OperatorLoginComponent,
		OperatorSignupComponent,
		OneTimePasswordComponent
	],
	imports: [
		CommonModule,
		FormsModule,
		AppMaterialModule,
		XpKitModule
	],
	exports: [
		OperatorLoginComponent,
		OperatorSignupComponent,
		OneTimePasswordComponent
	]
})
export class OperatorAuthModule { }
